/**
 * TemplateSelector Component
 * 
 * Dropdown for selecting agreement template type
 * Supports all 5 template options with descriptions
 * Integrated with i18next for multilingual labels
 */
import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from './ui/select';
import { Label } from './ui/label';

const TEMPLATE_OPTIONS = [
  'LOAN',
  'FREELANCER_WORK',
  'PROPERTY_TOKEN',
  'VENDOR_ADVANCE',
  'PERSONAL_SETTLEMENT'
];

const TemplateSelector = ({ value, onChange, disabled = false, className = '' }) => {
  const { t, getTemplateName, getTemplateDescription } = useLanguage();

  return (
    <div className={`space-y-2 ${className}`}>
      <Label htmlFor="template-selector">
        {t('templates.select_template')}
      </Label>
      <Select
        value={value}
        onValueChange={onChange}
        disabled={disabled}
      >
        <SelectTrigger id="template-selector" className="w-full">
          <SelectValue placeholder={t('templates.select_template')}>
            {value ? getTemplateName(value) : t('templates.select_template')}
          </SelectValue>
        </SelectTrigger>
        <SelectContent>
          {TEMPLATE_OPTIONS.map((templateType) => (
            <SelectItem key={templateType} value={templateType}>
              <div className="flex flex-col">
                <span className="font-medium">{getTemplateName(templateType)}</span>
                <span className="text-xs text-muted-foreground">
                  {getTemplateDescription(templateType)}
                </span>
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default TemplateSelector;
